import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ModalData {
  children: unknown
  props: unknown
}

interface ModalState {
  /** 提示 Modal 資料 */
  hintModalData: ModalData
  /** 全局 Modal 資料 */
  globalModalData: ModalData
}

const initialState: ModalState = {
  /** 提示 Modal 資料 */
  hintModalData: {
    children: null,
    props: null,
  },
  /** 全局 Modal 資料 */
  globalModalData: {
    children: null,
    props: null,
  },
}

const slice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openHintModal: (state, action: PayloadAction<ModalData>) => {
      state.hintModalData = action.payload
    },
    closeHintModal: (state, action: PayloadAction<void>) => {
      state.hintModalData = initialState.hintModalData
    },
    openGlobalModal: (state, action: PayloadAction<ModalData>) => {
      state.globalModalData = action.payload
    },
    closeGlobalModal: (state, action: PayloadAction<void>) => {
      state.globalModalData = initialState.globalModalData
    },
  },
})

export const { actions } = slice
export default slice.reducer
